import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { ExamConfigBox, Spinner, Modal } from "../../components";
import { createExam } from "./examActions";
import { Box } from "@mui/material";

const books = [
  {
    id: "CIENCIAS_DA_NATUREZA",
    title: "Ciências da natureza e suas tecnologias",
    description: "45 Questões de Biologia, Física e Química",
    icon: "ciencias"
  },
  {
    id: "MATEMATICA",
    title: "Matemática e suas tecnologias",
    description: "45 Questões de Matemática",
    icon: "matematica"
  },
  {
    id: "LINGUAGENS",
    title: "Liguagens e códigos",
    description:
      "45 Questões de Lingua Portuguesa, Literatura, Inglês ou Espanhol, Artes e Educação Física",
    icon: "linguagens",
    options: [
      { text: "Inglês", value: "INGLES" },
      { text: "Espanhol", value: "ESPANHOL" }
    ]
  },
  {
    id: "CIENCIAS_HUMANAS",
    title: "Ciências humanas e suas tecnologias",
    description: "45 questões História, Geografia, Filosofia e Sociologia",
    icon: "humanas"
  }
];

const days = [
  {
    id: 1,
    title: "ENEM 1º dia",
    description: (
      <span>
        90 Questões
        <br />
        Caderno de Ciências Humanas
        <br />
        Caderno de Linguagens e Códigos
      </span>
    ),
    icon: "modulo",
    options: [
      { text: "Inglês", value: "INGLES" },
      { text: "Espanhol", value: "ESPANHOL" }
    ]
  },
  {
    id: 2,
    title: "ENEM 2º dia",
    description: (
      <span>
        90 Questões
        <br />
        Caderno de Ciências da Natureza
        <br />
        Caderno de Matemática
      </span>
    ),
    icon: "modulo"
  }
];

class ExamConfigPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modular: {
        CIENCIAS_HUMANAS: 0,
        LINGUAGENS: 0,
        CIENCIAS_DA_NATUREZA: 0,
        MATEMATICA: 0
      },
      modularLanguage: null,
      languageInfoModalOpen: false
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.exam !== this.props.exam) {
      this.props.history.push("/questao");
    }
  }

  handleInputChange(e) {
    const modular = { ...this.state.modular };
    if (e.target.value > 45) {
      e.target.value = 45;
    }
    if (e.target.value != null) {
      if (e.target.value === "") {
        modular[e.target.name] = "";
      } else if (
        isNaN(Number(e.target.value)) ||
        Number(e.target.value) < 0 ||
        e.target.value[0] === "0"
      ) {
        modular[e.target.name] = 0;
      } else if (
        Number(e.target.value) > this.getAvailableQuestions(e.target.name)
      ) {
        modular[e.target.name] = this.getAvailableQuestions(e.target.name);
      } else {
        modular[e.target.name] = Number(e.target.value);
      }
    } else {
      modular[e.target.name] = 0;
    }

    this.setState({ modular });
  }

  handleInputBlur(e) {
    if (e.target.value === "") {
      const modular = { ...this.state.modular };
      modular[e.target.name] = 0;

      this.setState({ modular });
    }
  }

  createExam(type, id, language) {
    if (
      !language &&
      ((type === "book" && id === "LINGUAGENS") || (type === "day" && id === 1))
    ) {
      this.setState({ languageInfoModalOpen: true });
      return;
    }

    const examConfig = {
      type: type,
      [type === "BOOK" ? "book" : "day"]: id,
      language: language
    };

    this.props.createExam(examConfig);
  }

  getAvailableQuestions(module) {
    const { modular } = this.state;

    module = module < 0 ? 0 : module;
    let availableQuestions = 0;

    switch (module) {
      case "LINGUAGENS":
        availableQuestions =
          90 -
          ((modular.MATEMATICA === "" ? 0 : modular.MATEMATICA) +
            (modular.CIENCIAS_DA_NATUREZA === ""
              ? 0
              : modular.CIENCIAS_DA_NATUREZA) +
            (modular.CIENCIAS_HUMANAS === "" ? 0 : modular.CIENCIAS_HUMANAS));
        break;
      case "MATEMATICA":
        availableQuestions =
          90 -
          ((modular.LINGUAGENS === "" ? 0 : modular.LINGUAGENS) +
            (modular.CIENCIAS_DA_NATUREZA === ""
              ? 0
              : modular.CIENCIAS_DA_NATUREZA) +
            (modular.CIENCIAS_HUMANAS === "" ? 0 : modular.CIENCIAS_HUMANAS));
        break;
      case "CIENCIAS_DA_NATUREZA":
        availableQuestions =
          90 -
          ((modular.LINGUAGENS === "" ? 0 : modular.LINGUAGENS) +
            (modular.MATEMATICA === "" ? 0 : modular.MATEMATICA) +
            (modular.CIENCIAS_HUMANAS === "" ? 0 : modular.CIENCIAS_HUMANAS));
        break;
      case "CIENCIAS_HUMANAS":
        availableQuestions =
          90 -
          ((modular.LINGUAGENS === "" ? 0 : modular.LINGUAGENS) +
            (modular.MATEMATICA === "" ? 0 : modular.MATEMATICA) +
            (modular.CIENCIAS_DA_NATUREZA === ""
              ? 0
              : modular.CIENCIAS_DA_NATUREZA));
        break;
      default:
        availableQuestions = 0;
    }

    return availableQuestions < 0 ? 0 : availableQuestions;
  }

  createModularExam() {
    const { modular, modularLanguage } = this.state;

    if (modular.LINGUAGENS > 0 && !modularLanguage) {
      this.setState({ languageInfoModalOpen: true });
      return;
    }

    if (
      (modular.LINGUAGENS === "" ? 0 : modular.LINGUAGENS) +
      (modular.MATEMATICA === "" ? 0 : modular.MATEMATICA) +
      (modular.CIENCIAS_DA_NATUREZA === ""
        ? 0
        : modular.CIENCIAS_DA_NATUREZA) +
      (modular.CIENCIAS_HUMANAS === "" ? 0 : modular.CIENCIAS_HUMANAS) >
      0 &&
      (modular.LINGUAGENS === 0 ||
        modular.LINGUAGENS === "" ||
        modularLanguage != null)
    ) {
      let modular = [];
      for (let moduleType in this.state.modular) {
        if (this.state.modular[moduleType]) {
          let module = {
            book: moduleType,
            quantity: this.state.modular[moduleType]
          };

          modular.push(module);
        }
      }

      let examConfig = {
        type: "MODULAR",
        language: this.state.modular.LINGUAGENS
          ? this.state.modularLanguage
          : null,
        modular: modular
      };

      this.props.createExam(examConfig);
    }
  }

  render() {
    const { modular, modularLanguage } = this.state;

    return (
      <div className="wrapper">
        <div className="vertical-large horizontal-medium padded content">
          <h2 className="text-center bold">Como fazer</h2>
          <div className="medium-spacing text-justify hide-for-small-only">
            <p>É muito simples!</p>
            <p>
              Ao escolher fazer o <strong>simulado por caderno</strong> você
              estará escolhendo fazer por área de conhecimento: Ciências da
              Natureza, Ciências Humanas, Linguagens (inglês / espanhol) ou
              Matemática.
            </p>
            <p>
              Já o <strong>simulado por dia</strong> segue o modelo da prova do
              ENEM, onde é possível selecionar as provas do 1º ou 2º dia.
            </p>
            <p>
              Por último, no <strong>simulado modular</strong> é possível montar
              o simulado do seu jeito. Você pode escolher quantas questões
              quiser de cada área do conhecimento. Trata-se de um simulado
              personalizado.
            </p>
          </div>
          <div className="medium-spacing text-justify hide-for-medium hide-for-large">
            <p>
              <strong>SIMULADO POR CADERNO</strong> de acordo com cada área do
              conhecimento.
            </p>
            <p>
              <strong>SIMULADO POR DIA</strong> seguindo o modelo das provas do
              1º ou 2º dia do ENEM.
            </p>
            <p>
              <strong>SIMULADO MODULAR</strong> onde é possível personalizar e
              escolher quantas questões quiser de cada área do conhecimento.
            </p>
          </div>
          <section className="exam-type">
            <h4 className="primary">Simulado por caderno</h4>
            <div className="grid-x grid-margin-x grid-margin-y">
              {books.map(book => {
                return (
                  <div key={book.id} className="small-12 medium-6 cell">
                    <ExamConfigBox
                      id={book.id}
                      title={book.title}
                      description={book.description}
                      icon={book.icon}
                      options={book.options}
                      onStart={(id, selectedOption) =>
                        this.createExam("BOOK", id, selectedOption)
                      }
                    />
                  </div>
                );
              })}
            </div>
          </section>
          <section className="exam-type">
            <h4 className="primary">Simulado por dia</h4>
            <div className="grid-x grid-margin-x grid-margin-y">
              {days.map(day => {
                return (
                  <div key={day.id} className="small-12 medium-6 cell">
                    <ExamConfigBox
                      id={day.id}
                      title={day.title}
                      description={day.description}
                      icon={day.icon}
                      options={day.options}
                      onStart={(id, selectedOption) =>
                        this.createExam("DAY", id, selectedOption)
                      }
                    />
                  </div>
                );
              })}
            </div>
          </section>
          <section className="exam-type">
            <h4 className="primary">Simulado modular</h4>
            <div className="grid-x grid-margin-x grid-margin-y">
              <div className="small-12 cell">
                <div className="exam-config-box custom grid-x">
                  <div className="exam-config-box__icon-area">
                    <i className="icon-custom" />
                  </div>
                  <div className="exam-config-box__custom-area grid-x grid-margin-x align-middle">
                    <div className="small-12 large-3 cell">
                      <div className="exam-config-box__content">
                        <h6>Crie o seu simulado</h6>
                        <small>
                          *Os simulados poderão conter até 90 questões
                        </small>
                      </div>
                    </div>
                    <div className="small-12 large-3 cell align-self-stretch">
                      <div className="exam-config-box__custom-area__count-container">
                        <strong>Quantidade de questões</strong>
                        <div className="exam-config-box__custom-area__count">
                          {(modular.LINGUAGENS === ""
                            ? 0
                            : modular.LINGUAGENS) +
                            (modular.MATEMATICA === ""
                              ? 0
                              : modular.MATEMATICA) +
                            (modular.CIENCIAS_DA_NATUREZA === ""
                              ? 0
                              : modular.CIENCIAS_DA_NATUREZA) +
                            (modular.CIENCIAS_HUMANAS === ""
                              ? 0
                              : modular.CIENCIAS_HUMANAS)}
                          /90
                        </div>
                        <small className="show-for-large">
                          questões selecionadas
                        </small>
                      </div>
                    </div>
                    <div className="small-12 large-6 cell">
                      <div className="exam-config-box__custom-area__form">
                        <div className="grid-x grid-margin-x align-middle tiny-spacing">
                          <div className="shrink cell">
                            <input
                              id="count-linguagens"
                              type="number"
                              className="tiny-input"
                              name="LINGUAGENS"
                              value={modular.LINGUAGENS}
                              min={0}
                              max={45}
                              onChange={e => this.handleInputChange(e)}
                              onFocus={e => e.target.select()}
                              onBlur={e => this.handleInputBlur(e)}
                            />
                          </div>
                          <div className="auto cell">
                            <label htmlFor="count-linguagens">
                              <span className="show-for-large">
                                Caderno de{" "}
                              </span>
                              Linguagens e Códigos
                            </label>
                            <div>
                              <input
                                id="modular-english"
                                checked={modularLanguage === "INGLES"}
                                type="radio"
                                onChange={e =>
                                  this.setState({ modularLanguage: "INGLES" })
                                }
                              />
                              <label htmlFor="modular-english">Inglês</label>
                              <input
                                id="modular-spanish"
                                checked={modularLanguage === "ESPANHOL"}
                                type="radio"
                                onChange={e =>
                                  this.setState({ modularLanguage: "ESPANHOL" })
                                }
                              />
                              <label htmlFor="modular-spanish">Espanhol</label>
                            </div>
                          </div>
                        </div>

                        <div className="grid-x grid-margin-x align-middle tiny-spacing">
                          <div className="shrink cell">
                            <input
                              id="count-humanas"
                              type="number"
                              className="tiny-input"
                              name="CIENCIAS_HUMANAS"
                              value={modular.CIENCIAS_HUMANAS}
                              min={0}
                              max={45}
                              onChange={e => this.handleInputChange(e)}
                              onFocus={e => e.target.select()}
                              onBlur={e => this.handleInputBlur(e)}
                            />
                          </div>
                          <div className="auto cell">
                            <label htmlFor="count-humanas">
                              <span className="show-for-large">Cadrno de </span>
                              Ciências Humanas
                            </label>
                          </div>
                        </div>

                        <div className="grid-x grid-margin-x align-middle tiny-spacing">
                          <div className="shrink cell">
                            <input
                              id="count-matematica"
                              type="number"
                              className="tiny-input"
                              name="MATEMATICA"
                              value={modular.MATEMATICA}
                              min={0}
                              max={45}
                              onChange={e => this.handleInputChange(e)}
                              onFocus={e => e.target.select()}
                              onBlur={e => this.handleInputBlur(e)}
                            />
                          </div>
                          <div className="auto cell">
                            <label htmlFor="count-matematica">
                              <span className="show-for-large">
                                Caderno de{" "}
                              </span>
                              Matemática
                            </label>
                          </div>
                        </div>

                        <div className="grid-x grid-margin-x align-middle tiny-spacing">
                          <div className="shrink cell">
                            <input
                              id="count-ciencias"
                              type="number"
                              className="tiny-input"
                              name="CIENCIAS_DA_NATUREZA"
                              value={modular.CIENCIAS_DA_NATUREZA}
                              min={0}
                              max={45}
                              onChange={e => this.handleInputChange(e)}
                              onFocus={e => e.target.select()}
                              onBlur={e => this.handleInputBlur(e)}
                            />
                          </div>
                          <div className="auto cell">
                            <label htmlFor="count-ciencias">
                              <span className="show-for-large">Cadrno de </span>
                              Ciências da Natureza
                            </label>
                          </div>
                        </div>

                        <button
                          type="button"
                          className="small success button"
                          onClick={() => this.createModularExam()}
                        >
                          Iniciar
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <Modal
            isVisible={this.state.languageInfoModalOpen}
            onCloseModal={() => this.setState({ languageInfoModalOpen: false })}
          >
            <div className="text-center">
              <h1 className="modal-container__title">OPS!</h1>
              <p className="modal-container__text-info">
                Você não pode prosseguir sem escolher qual prova de línguas
                deseja fazer
              </p>
            </div>
          </Modal>
          <Spinner
            isLoading={this.state.loading}
            message="Aguarde... Montando seu exame"
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  exam: state.exam.exam,
  loading: state.exam.loading
});

export default connect(mapStateToProps, { createExam })(ExamConfigPage);
